export class ServerWindowMock {}
